import { render } from "./CandidateLetters.vue?vue&type=template&id=17ecb0fb&scoped=true"
import script from "./CandidateLetters.vue?vue&type=script&lang=js"
export * from "./CandidateLetters.vue?vue&type=script&lang=js"

import "./CandidateLetters.vue?vue&type=style&index=0&id=17ecb0fb&lang=scss&scoped=true"

import exportComponent from "/build/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17ecb0fb"]])

export default __exports__